export const TEMPLATE_NAME_FIELD = 'name'
